(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sh-cart-indicator"] && !Shopify.designMode) return;
  try {
    (function(){
  if(window.SickHausCartIndicator)return;
  const states=new WeakMap();
  function observe(link){
    if(states.has(link))return;
    const count=link.querySelector('.cart-link__bubble-num');if(!count)return;
    states.set(link,true);
    const label=link.querySelector('.icon__fallback-text')?.textContent.trim()||'';
    let previous=Number(count.textContent)||0;
    let timer;
    const icon=link.querySelector('.cart-link');
    function sync(){
      const next=Number(count.textContent)||0;
      link.setAttribute('aria-label',label+' '+next);
      link.querySelector('.cart-link__bubble')?.setAttribute('aria-hidden','true');
      if(icon&&next>previous){
        clearTimeout(timer);
        icon.classList.remove('sh-cart-added');
        void icon.offsetWidth;
        icon.classList.add('sh-cart-added');
        timer=setTimeout(()=>icon.classList.remove('sh-cart-added'),850);
      }
      if(!next&&icon){clearTimeout(timer);icon.classList.remove('sh-cart-added');}
      previous=next;
    }
    new MutationObserver(sync).observe(count,{childList:true,characterData:true,subtree:true});sync();
  }
  function init(){document.querySelectorAll('[data-sh-cart-page-link]').forEach(observe);}
  window.SickHausCartIndicator={init};if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init,{once:true});}else{init();}document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sh-trending-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sh-trending-tabs')) {
    customElements.define('sh-trending-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enhanced) return;
        this.tabs = Array.from(this.querySelectorAll('[data-trending-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-trending-panel]'));
        this.querySelector('nav').setAttribute('role', 'tablist');
        this.tabs.forEach(tab => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', tab.hash.slice(1));
          tab.addEventListener('click', event => { event.preventDefault(); this.select(tab); });
          tab.addEventListener('keydown', event => {
            const index = this.tabs.indexOf(tab);
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next !== undefined) { event.preventDefault(); this.select(this.tabs[next]); this.tabs[next].focus(); }
          });
        });
        this.panels.forEach(panel => panel.setAttribute('role', 'tabpanel'));
        this.select(this.tabs[0]);
        this.dataset.enhanced = 'true';
      }
      select(tab) {
        this.tabs.forEach(item => { const active = item === tab; item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; });
        this.panels.forEach(panel => { panel.hidden = panel.dataset.trendingPanel !== tab.dataset.trendingTab; });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sickhaus-selection-guidance"] && !Shopify.designMode) return;
  try {
    (function(){
  function update(event){
    var variant=event.detail&&event.detail.variant;
    var root=event.target.closest('.sh-studio');
    if(!variant||!root)return;
    var panel=root.querySelector('[data-sh-selection-guidance]');
    if(!panel)return;
    var source=panel.querySelector('[data-sh-contents-map]');
    if(!source)return;
    var map;
    try{map=JSON.parse(source.textContent);}catch(e){return;}
    var copy=panel.querySelector('[data-sh-contents-copy]');
    if(copy&&Object.prototype.hasOwnProperty.call(map,String(variant.id)))copy.textContent=map[String(variant.id)];
  }
  document.addEventListener('sickhaus:variant-change',update);
})();
  } catch(e) { console.error(e); }
})();

})();
